/**
 * main.ts — entry point
 * Bootstraps the AppShell and attaches the FlipBookRenderer.
 */
import "./style.css";
import { AppShell } from "./app";
import { FlipBookRenderer } from "./book/flip-renderer";
import { loadBookContent } from "./book/content";

const root = document.getElementById("app-shell");
if (!root) throw new Error("#app-shell not found");

const shell = new AppShell(root);
shell.mount();

loadBookContent().then((book) => {
  shell.attachRenderer(new FlipBookRenderer(book));
});
